"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _BaseTheme = _interopRequireDefault(require("../Themes/BaseTheme"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Theme
const SmallText = _styledComponents.default.small.withConfig({
  displayName: "SmallText",
  componentId: "design-system__sc-1iemiy-0"
})(["font-family:", ";font-size:", ";"], _BaseTheme.default.type.family.content, _BaseTheme.default.type.size.small);

var _default = SmallText;
exports.default = _default;